import React, { useEffect, useState } from 'react';
import './dashboard-payments.container.sass';
import { useDispatch, useSelector } from 'react-redux';
import { getTeamVendorId } from '../../login/session.slice';
import { getInvoiceData, getTransactions, getTransactionsPeriod } from './dashboard-payment.slice';
import { InvoiceData } from './components/invoice-data/invoice-data';
import { PaymentSummary } from './components/summary/payment-summary';
import { TableRow } from '../../../components/interface/table/tableRow';
import { Dropdown, DropdownSize } from '../../../components/interface/input/dropdown/dropdown';
import { getTeamUsers } from '../team/dashboard-team.slice';
import { TransactionAmountService } from '../../../services/transaction-amount-service/transaction-amount.service';
import { DateService } from './payment-date-service/payment-date.service';
import { getAvailablePlans, getCurrentPlan } from './dashboard-plan.slice';
import { Button, ButtonSize, ButtonType } from '../../../components/interface/button/button';
import { DashboardPaymentsModalPlan } from './modal/plan/dashboard-payments-modal-plan';

const TransactionStatus = {
  'SUCCESS': 'complete',
  'REJECTED': 'failed'
};

const filter = {
  status: undefined,
  dateFrom: undefined,
  dateTo: undefined,
  user: undefined
};

export const DashboardPaymentsContainer = () => {

  const sessionData = useSelector(state => state.session);
  const paymentData = useSelector(state => state.dashboardPayment);
  const vendorId = getTeamVendorId(sessionData);
  const dashboardTeamData = useSelector(state => state.dashboardTeam);
  const plans = useSelector(state => state.dashboardPlan.availablePlans);
  const currentPlan = useSelector(state => state.dashboardPlan.currentPlan);
  const users = dashboardTeamData.users || [];
  const dispatch = useDispatch();

  //FIXME MOCK DATA //GET INVOICES REQUEST
  const items = paymentData.transactions;

  const transactionsPeriod = paymentData.transactionsPeriod;

  const userOptions = users.map(e => ({label: e.user?.first_name, value: e.user?.id}));
  userOptions.push({label: 'Wszyscy'});
  const billingOptions = DateService.getDateOptions();
  const statusOptions = [{label: 'Sukces', value: TransactionStatus.SUCCESS}, {label: 'Odrzucona', value: TransactionStatus.REJECTED}, {label: 'Wszystkie'}];

  const [paymentModalVisibility, setPaymentModalVisibility] = useState(false);
  useEffect(() => {
    dispatch(getAvailablePlans());
    dispatch(getTransactionsPeriod({vendorId}));
    dispatch(getInvoiceData({vendorId}));
    dispatch(getTransactions({vendorId}));
    dispatch(getTeamUsers({vendorId}));
    dispatch(getCurrentPlan({vendorId}));
  }, []);


  const renderHeader = () => {
    return <TableRow header classNames='vv-dashboard-team-container-header'>
      <div data-flex={1}>
        <span>Data</span>
      </div>
      <div data-flex={1}>
        <span>ID transakcji</span>
      </div>
      <div data-flex={1}>
        <span>Status</span>
      </div>
      <div data-flex={1}>
        <span>Kwota transakcji (zł)</span>
      </div>
      <div data-flex={1}>
        <span>Zniżka (%)</span>
      </div>
      <div data-flex={1}>
        <span>Kwota zniżki</span>
      </div>
      <div data-flex={1}>
        <span>Kwota prowizji</span>
      </div>
    </TableRow>;
  };

  const renderRow = (e, i) => {
    return <TableRow classNames='vv-dashboard-payments-container-row' >
      <div data-flex={1}>
        <span>{new Date(e.date).toLocaleDateString()}</span>
      </div>
      <div data-flex={1}>
        <span>{e.transaction_id}</span>
      </div>
      <div data-flex={1}>
        <span className={`vv-dashboard-payments-container-row__${e.status === TransactionStatus.SUCCESS ? 'active' : 'inactive'}`}>{e.status === TransactionStatus.SUCCESS ? 'Sukces' : 'Odrzucona'}</span>
      </div>
      <div data-flex={1}>
        <span>{TransactionAmountService.convertTransactionAmount(e?.amount?.amount)}</span>
      </div>
      <div data-flex={1}>
        <span>{e?.discount + ' %'}</span>
      </div>
      <div data-flex={1}>
        <span>{TransactionAmountService.convertTransactionAmount(e?.amount_user_discount?.amount)}</span>
      </div>
      <div data-flex={1}>
        <span>{TransactionAmountService.convertTransactionAmount(e?.amount_vice_versa?.amount)}</span>
      </div>

    </TableRow>;
  };

  const getFilteredTransactionsStatus = (status) => {
    filter.status = status;
    dispatch(getTransactions({vendorId, filter}));
  };

  const getFilteredTransactionsUser = (user_id) => {
    filter.user = user_id;
    dispatch(getTransactions({vendorId, filter}));
  };

  const getFilteredTransactionsDate = (dateFrom, dateTo) => {
    filter.dateFrom = dateFrom;
    filter.dateTo = dateTo;
    dispatch(getTransactions({vendorId, filter}));
  };

  return (
    <div className='vv-dashboard-payment-container'>
      <div className='vv-dashboard-payment-container__top'>
        <div className='margin-right'>
          <h3>Podsumowanie</h3>
          { transactionsPeriod && <PaymentSummary transactionsPeriod={transactionsPeriod}/>}
        </div>
        <div>
          <h3>Dane do faktury</h3>
          {paymentData?.isFetched ? <InvoiceData
            name={paymentData?.invoiceData?.invoice_name}
            nip={paymentData?.invoiceData?.invoice_nip}
            city={paymentData?.invoiceData?.invoice_city}
            postalCode={paymentData?.invoiceData?.invoice_postal_code}
            street={paymentData?.invoiceData?.invoice_address}/> : null}
          <div className='vv-dashboard-payment-container__plan-container'>
            <h3>Twój plan</h3>
            <h4>{currentPlan.plan?.name} - {currentPlan.plan?.price_label}</h4>
            <Button text='zmień plan' buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR} onClick={() => setPaymentModalVisibility(true)}/>
          </div>
          <DashboardPaymentsModalPlan isVisible={paymentModalVisibility} setIsVisible={(value) => {
            setPaymentModalVisibility(value);
            dispatch(getCurrentPlan({vendorId}));
          }} plans={plans} currentPlan={currentPlan}/>
        </div>
      </div>
      <div className='vv-dashboard-payment-container__bottom'>
        <h3>Historia transakcji</h3>
        <div className='vv-dashboard-payment-container__filter-container'>
          <div className='filter-margin'>
            <Dropdown name='billing-period' id='billing-period' label='Okres rozliczeniowy' options={billingOptions} size={DropdownSize.SMALL} placeholder='Okres...' onChange={(option) => getFilteredTransactionsDate(option.value?.dateFrom, option.value?.dateTo)}/>
          </div>
          <div className='filter-margin'>
            <Dropdown name='billing-status' id='billing-status' label='Status' options={statusOptions} size={DropdownSize.SMALL} placeholder='Status...' onChange={(option) => getFilteredTransactionsStatus(option.value)}/>
          </div>
          <Dropdown name='billing-user' id='billing-user' label='Pracownik' options={userOptions} size={DropdownSize.SMALL} placeholder='Pracownik...' onChange={(option) => getFilteredTransactionsUser(option.value)}/>
        </div>
        <div className='vv-dashboard-payment-container__table-container'>
          {renderHeader()}
          {items.map(renderRow)}
        </div>
      </div>
    </div>
  );
};
